import { Building2, Church, Heart, MapPin, Megaphone, Users, type LucideIcon } from 'lucide-react'
import type { ExperienceKey } from '../frentes'

/* ERP · ícone de cada experiência (menu do Staff, cabeçalho da visão). Fora de frentes.ts para o catálogo seguir sem React. */

export const EXPERIENCE_ICONS: Record<ExperienceKey, LucideIcon> = {
    sponsor: Heart, staff: Users, corporate: Building2, faith: Church, ambassadors: Megaphone, osp: MapPin,
}
